import React, { useState, useRef, useEffect } from 'react';
import {InputGroup, Input, Spinner} from 'reactstrap';
import './style.scss';

export default function InputField({ onSubmit, ...props }) {
    const [value, handleChange] = useState('');
    const inputEl = useRef(null);
    const searchChange = (e) => {
        if(!props.disabled){
            if (e.key === 'Enter') {
                if(e.target.value.trim()){
                    if(props.parrentDataHandling) {
                        onSubmit(props.value);
                    } else {
                        onSubmit(value);
                    }
                }
            } else if(props.parrentDataHandling) {
                props.handleChange(e.target.value);
            } else {
                handleChange(e.target.value);
            }
        }
    };

    useEffect(() => {
        if (props.highlightOnFocus) {
            inputEl.current.select();
        }
    }, [props.highlightOnFocus]);

    const handleFocus = (event) => event.target.select();

    return (
        <InputGroup style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Input
                onKeyPress={(e) => searchChange(e)}
                onChange={(e) => searchChange(e)}
                value={props.parrentDataHandling ? props.value : value}
                placeholder={props.inputPlaceholder}
                type="text"
                className="create-fetch_input"
                style={{ paddingRight: props.showSubmitGlass ? '55px' : '30px'  }}
                id="facebook-input"
                autoComplete="off"
                disabled={props.disabled}
                innerRef={inputEl}
                onBlur={props.onBlur}
            />
            {(!props.disabled && ((props.parrentDataHandling && props.value && props.value.trim()) || value && value.trim())) && (
                <i
                    style={props.showSubmitGlass ? {} : { right: '4px' }}
                    onClick={
                        props.cleanPreview 
                        ? () => props.cleanPreview()
                        : () => props.parrentDataHandling 
                            ? props.handleChange('') 
                            : handleChange('')
                    }
                    className="fa fa-times-circle create-fetch_inputicon-cross"
                />
            )}
            {!props.disabled && props.showSubmitGlass && ((props.parrentDataHandling && props.value.trim()) || value.trim()) && (
                <React.Fragment>
                    {props.loading ? (
                        <div className="create-fetch_inputicon-glass" style={{ display: 'flex' }}>
                            {/*<i className="fa fa-spinner fa-spin" />*/}
                            <Spinner style={{height: '.95rem', width: '.95rem', borderWidth: '2px', position: 'relative', top: '-1px'}} />
                        </div>
                    ) : (
                        <i
                            onClick={() => onSubmit(props.parrentDataHandling ? props.value : value)}
                            className="fa fa-search create-fetch_inputicon-glass"
                        />
                    )}
                </React.Fragment>
            )}
        </InputGroup>
    );
}
